// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + {"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] + "." + {"189":"53af2974f5d31fa98966","404":"2c42f5e2b4e541324d50","406":"1cc616ff412e75d08adf"}[chunkId] + ".css";
};